import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons';
import { FormattedMessage } from 'react-intl';
import { generatePath } from 'react-router-dom';
import styled from 'styled-components';

import IconButton from '@sorare/core/src/atoms/buttons/IconButton';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { HeadlineL } from '@sorare/core/src/atoms/typography';
import { FOOTBALL_PLAY_RIVALS_LEAGUES_SLUG } from '@sorare/core/src/constants/__generated__/routes';
import useSafePreviousNavigate from '@sorare/core/src/hooks/useSafePreviousNavigate';
import { navLabels } from '@sorare/core/src/lib/glossary';
import { useTypedParams } from '@sorare/core/src/lib/routing';

import { MembersList } from 'components/rivalsUserGroup/MembersList';

import { PageParams } from './__generated__/routeParams';

const HeaderWrapper = styled(Vertical)`
  padding: var(--double-unit) var(--double-unit) 0;
`;

const StyledHeadlineL = styled(HeadlineL)`
  padding: var(--double-unit);
`;
const MembersPage = () => {
  const { slug: userGroupSlug } = useTypedParams<PageParams>();
  const onBack = useSafePreviousNavigate(
    generatePath(FOOTBALL_PLAY_RIVALS_LEAGUES_SLUG, {
      slug: userGroupSlug,
    })
  );
  return (
    <Vertical>
      <HeaderWrapper gap={2}>
        <IconButton color="tertiary" icon={faChevronLeft} onClick={onBack} />
      </HeaderWrapper>
      <MembersList
        userGroupSlug={userGroupSlug}
        title={membersCount => (
          <StyledHeadlineL>
            <FormattedMessage {...navLabels.members} />
            {membersCount ? ` (${membersCount})` : ''}
          </StyledHeadlineL>
        )}
      />
    </Vertical>
  );
};
export default MembersPage;
